import axios from 'axios'
import ApiService from '@/services/api.service'

const GeoLocationService = {
  getFromLatLng: async function(latlng) {
    ApiService.removeHeader()
    const openCage = axios.create({
      baseURL: 'https://api.opencagedata.com'
    })
    // delete openCage.defaults.headers.common['Authorization']
    try {
      const res = await openCage.get('/geocode/v1/json', {
        params: {
          q: `${latlng.lat},${latlng.lng}`,
          key: 'f4846eacf3c34f1bad93b4896e7d768a'
        }
      })
      return res.data
    } catch (e) {
      console.log(e)
    } finally {
      ApiService.setHeader()
    }
  }
}

export default GeoLocationService
